import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React, { PureComponent } from 'react'
import { TranslationFunction } from 'react-i18next'
import { Link } from 'react-router-dom'

import { PureSelect } from 'modules/forms'

import { i18nKeys } from '../../../app.i18n'
import { links } from '../../../app.links'
import { AvatarSizes, ImageSource, toFixed, UserAvatar } from '../../../shared'
// import { Percentage, toFixed } from '../../my-review/shared'
import { CoreValueItems } from '../../shared/review/form-lookups'

import './reviews-subordinate-readonly.scss'

type Props = {
  employeeId: number
  employeeName: string
  translate: TranslationFunction
  disabled: boolean
  imageSource: ImageSource

  primaryCoreValue: number
  overallValue: number
  goalOverviewRating: number | null
  finalRating: number | null
}

export class ReviewsSubordinateReadonlyEndYear extends PureComponent<Props> {
  render() {
    const {
      translate,
      employeeId,
      employeeName,
      disabled,
      goalOverviewRating,
      primaryCoreValue,
      overallValue,
      imageSource,
      finalRating,
    } = this.props

    return (
      <div className="droppable-subordinate">
        <div className="droppable-subordinate__item droppable-subordinate__drag-handle">
          <Icon icon={IconNames.DRAG_HANDLE_VERTICAL} title={false} />
        </div>
        <UserAvatar
          className="droppable-subordinate__avatar"
          userName={employeeName}
          imageSource={imageSource}
          avatarSize={AvatarSizes.LIST}
        />
        <div className="droppable-subordinate__item droppable-subordinate__name">
          <Link to={links.frontFace.team.byUser.review(employeeId)}>{employeeName}</Link>
        </div>
        <div className="droppable-employee__item">{goalOverviewRating}</div>
        <div className="droppable-subordinate__item droppable-subordinate__core-value">
          <PureSelect
            noSelectedOptionText={i18nKeys.core.common.selectEmptyOptionText}
            items={CoreValueItems}
            name=""
            initialValue={primaryCoreValue}
            translate={translate}
            disabled={disabled}
            shouldTranslateOptions
          />
        </div>
        <div className="droppable-employee__item">{toFixed(overallValue)}</div>
        <div className="droppable-employee__item">{toFixed(finalRating)}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/front-face/shared/reviews-subordinate-readonly/reviews-subordinate-readonly-end-year.tsx